import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from './locales/i18n'

import vuetify from "./plugins/vuetify";
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'

import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
